const queryString = require("query-string");

module.exports = function findQueryParameter(search, key) {
	const query_string = queryString.parse(search);
	return query_string && query_string[key] ? query_string[key] : null;
};
